// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `footer.footer {
  margin-top: 100px;
  background: #262630;
  color: white;
  width: 100%;
}

.powered-by img {
  height: 32px;
  width: 74px;
}

.footer-content .logo {
  display: flex;
  justify-content: center;
  border-bottom: 1px solid #f7f9fc4d;
  height: auto;
  width: 100%; /* Ensures the logo div takes full width */
}

.logo img {
  width: 60px;
  height: 60px;
  margin: 20px 0px;
}

.social-info-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 24px 20px;
}

.social-info-container div {
  width: 33.33%;
}

.powered-by {
  display: flex;
  justify-content: center;
  align-items: center;
}

.contacts {
  display: flex;
  text-align: end;
  justify-content: end;
  align-items: center;
}

img.social-icon {
  margin-left: 10px;
}

@media (max-width: 920px) {
  .footer-content {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .social-info-container {
    flex-direction: column;
    gap: 20px;
    align-items: center;
  }

  .social-info-container div {
    width: 100%;
    margin-bottom: 10px;
  }

  .social-info-container .copyright {
    order: 3; /* Move to the end */
  }

  .social-info-container .powered-by {
    order: 1;
  }

  .social-info-container .contacts {
    order: 2;
  }

  .powered-by,
  .contacts {
    justify-content: center;
  }

  .contacts {
    text-align: center;
  }

  .social-info-container div:last-child {
    margin-bottom: 0;
  }
  
  .social-info-container div {
    width: 100%;
    margin-bottom: 0px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/HomeLayout/styles.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kCAAkC;EAClC,YAAY;EACZ,WAAW,EAAE,0CAA0C;AACzD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,QAAQ,EAAE,oBAAoB;EAChC;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;AACF","sourcesContent":["footer.footer {\n  margin-top: 100px;\n  background: #262630;\n  color: white;\n  width: 100%;\n}\n\n.powered-by img {\n  height: 32px;\n  width: 74px;\n}\n\n.footer-content .logo {\n  display: flex;\n  justify-content: center;\n  border-bottom: 1px solid #f7f9fc4d;\n  height: auto;\n  width: 100%; /* Ensures the logo div takes full width */\n}\n\n.logo img {\n  width: 60px;\n  height: 60px;\n  margin: 20px 0px;\n}\n\n.social-info-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px 20px;\n}\n\n.social-info-container div {\n  width: 33.33%;\n}\n\n.powered-by {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.contacts {\n  display: flex;\n  text-align: end;\n  justify-content: end;\n  align-items: center;\n}\n\nimg.social-icon {\n  margin-left: 10px;\n}\n\n@media (max-width: 920px) {\n  .footer-content {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n  }\n\n  .social-info-container {\n    flex-direction: column;\n    gap: 20px;\n    align-items: center;\n  }\n\n  .social-info-container div {\n    width: 100%;\n    margin-bottom: 10px;\n  }\n\n  .social-info-container .copyright {\n    order: 3; /* Move to the end */\n  }\n\n  .social-info-container .powered-by {\n    order: 1;\n  }\n\n  .social-info-container .contacts {\n    order: 2;\n  }\n\n  .powered-by,\n  .contacts {\n    justify-content: center;\n  }\n\n  .contacts {\n    text-align: center;\n  }\n\n  .social-info-container div:last-child {\n    margin-bottom: 0;\n  }\n  \n  .social-info-container div {\n    width: 100%;\n    margin-bottom: 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
